import {axiosAPI} from "./axiosClient"
import { UserService } from './UserService';

import qs from "qs";
import { getParams } from '../helper/Helper'

export const AbonnementService = {
  getAbonnements(folderId, params) {
    return axiosAPI.get(`/${folderId}/abonnements?lookup=true&${getParams(params)}`)
  },
  getAbonnementsSummary(folderId, params) {
    return axiosAPI.get(`/${folderId}/abonnements/summary?lookup=true&${getParams(params)}`)
  },
  getAbonnementsBrouillon(folderId, params) {
    return axiosAPI.get(`/${folderId}/abonnements/brouillons?lookup=true&${getParams(params)}`)
  },
  postAbonnementsBrouillonsGenerate(folderId, dataPost){
    return axiosAPI.post(`/${folderId}/abonnements/brouillons/generate`, qs.stringify(dataPost))
  },
  /* getAbonnementsPDF(folderId, params) {
    return axiosAPI.get(`/${folderId}/abonnements?lookup=true&${getParams(params)}&format=pdf`, {responseType: 'blob'})
  }, */
  getAbonnement(folderId, abonnementId){
    return axiosAPI.get(`/${folderId}/abonnements/${abonnementId}?lookup=true`)
  },
  updateAbonnement(folderId, abonnementId){
    return axiosAPI.put(`/${folderId}/abonnements/${abonnementId}`)
  },
  duplicateAbonnement(folderId, abonnementId){
    return axiosAPI.post(`/${folderId}/abonnements/${abonnementId}/dupliquer`)
  },
  postAbonnement(folderId, dataPost){
    return axiosAPI.post(`/${folderId}/abonnements`, qs.stringify(dataPost))
  },
  removeAbonnements(folderId, abonnementIdList) {
    var params = '?abonnements[]=' + abonnementIdList.join('&abonnements[]=');
    return axiosAPI.delete(`/${folderId}/abonnements${params}`)
  },
  convertToProforma(folderId, abonnementId) {
    return axiosAPI.post(`/${folderId}/abonnements/${abonnementId}/convert/proforma`)
  },
  postGenerate(folderId, dataPost){
    return axiosAPI.post(`/${folderId}/abonnements/generate`, qs.stringify(dataPost))
  },
  postSendMails(folderId, dataPost){
    return axiosAPI.post(`/${folderId}/abonnements/sendmails`, qs.stringify(dataPost))
  },
  updateSuspension(folderId, abonnementId, dataPost){
    return axiosAPI.put(`/${folderId}/abonnements/${abonnementId}/suspensions`, qs.stringify(dataPost))
  },
  postSuspension(folderId, abonnementId, dataPost){
    return axiosAPI.post(`/${folderId}/abonnements/${abonnementId}/suspensions`, qs.stringify(dataPost))
  },
  removeSuspension(folderId, abonnementId, adresseId) {
    return axiosAPI.delete(`/${folderId}/abonnements/${abonnementId}/suspensions/${adresseId}`)
  },

}


/* 
GET /abonnements/summary => resumé des abonnement
POST /abonnements/brouillons/generate => génère les factures d'abonnement du mois en brouillons
GET /abonnements/brouillons => Récupère la liste des brouillons de facture d'abonnements du mois choisi
POST /abonnements/brouillons/validate => valide les brouillons en attente en facture définitive
GET /abonnements/emails => récupère le résumé des emails (pret ou déjà envoyés)
POST /abonnements/emails => envois le mailing et renvois un état détaillé du mailing
 */